import useElectricityMeter from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/useElectricityMeter'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import { getAuthorizationText } from '@/shared/utils/meterAuthorizationUtils'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import IconLockOpen from '@/shared/icons/NewDesign/IconLockOpen'

const EnedisAuth = () => {
  const { t, canRequestMeterData, isValidPdl, enedisAuth, enedisAuthHidden, handleAuthorizationClick } =
    useElectricityMeter({ type: 'client' })

  if (enedisAuthHidden || !canRequestMeterData) return null

  const primaryText = getAuthorizationText(t, 'cdf', 'elec')

  return (
    <SDNotification type='info' hidden={enedisAuth} primaryText={primaryText} border>
      <SDButton
        overrides={{
          BaseButton: {
            style: () => ({
              gap: '0.25rem',
            }),
          },
        }}
        block
        disabled={enedisAuth || !isValidPdl || !canRequestMeterData}
        onClick={handleAuthorizationClick}
      >
        <IconLockOpen color='white' />
        {t('subscriptionForm:pdl_module.enedis_authorization.authorize_yes')}
      </SDButton>
    </SDNotification>
  )
}

export default EnedisAuth
